import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Check if the current environment is development. */
export const IS_DEV = process.env.NODE_ENV === 'development';

/** Merge class names with Tailwind CSS classes */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Check if value is a function. */
export function isFunction(value: unknown): value is (...args: unknown[]) => unknown {
  return typeof value === 'function';
}

/** Check if value is a constructor. */
export function isConstructor(value: any): boolean {
  if (!isFunction(value)) return false;
  if (value.prototype && typeof value.prototype === 'object') return true;
  return false;
}

/** Get the appropriate key modifier symbol based on platform. */
export function getCtrlOrCmdKeyModifier(platform?: string): string {
  return platform === 'darwin' ? '⌘' : 'Ctrl';
}

/** Type guard helper that checks if value is instance of given type and returns it cast as that type or undefined if not. */
export const castAs = <T>(value: unknown, type: new (...args: any[]) => T): T | undefined =>
  value instanceof type ? value as T : undefined;

/** Blur the active input, textarea, or content editable element. */
export function blurActiveInputs() {
  const activeElement = document.activeElement as HTMLElement;
  if (activeElement && (
    activeElement.tagName === 'INPUT' ||
    activeElement.tagName === 'TEXTAREA' ||
    activeElement.contentEditable === 'true'
  )) {
    activeElement.blur();
  }
}

export { localStorageHelper } from './localStorageHelper';
